export const ERROR_SIGIL = '~error~';
// Perfkit topics
export const PERF_TEST_TOPIC = 'itsmetrics_test';
